export const partnerApplicationSteps = {
  stepOne: 'step-one',
  stepTwo: 'step-two',
  stepThree: 'step-three',
  stepFour: 'step-four',
};
